// import React, { useEffect, useState } from "react";
// import { auth, firestore as db } from "../FirebaseConfig";
// import { onAuthStateChanged, signOut } from "firebase/auth";
// import { doc, getDoc, updateDoc, setDoc } from "firebase/firestore";
// import { useLocation, useNavigate } from "react-router-dom";
// import toast from "react-hot-toast"; // Import toast for notifications

// const Account = () => {
//   const [user, setUser] = useState(null);
//   const [customer, setCustomer] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [showAddressForm, setShowAddressForm] = useState(false);
//   const [editIndex, setEditIndex] = useState(null);
//   const API_URL = "https://us-central1-tghc-web.cloudfunctions.net"; // Replace with your Firebase API URL


//   const [newAddress, setNewAddress] = useState({
//     customerName: "",
//     addressLine1: "",
//     addressLine2: "",
//     email: "",
//     phone: "",
//     City: "",
//     State: "",
//     Country: "India",
//     Pincode: "",
//   });
//   const [pincodeFetched, setPincodeFetched] = useState(false);


//   useEffect(() => {
//     // Only trigger when Pincode is exactly 6 digits and not fetched already
//     const pincode = newAddress.Pincode;
//     if (/^\d{6}$/.test(pincode) && !pincodeFetched) {
//       fetchCityStateForPincode(pincode);
//     }
//     // Reset fetched flag if pincode is cleared or changed to less than 6 digits
//     if (pincode.length !== 6 && pincodeFetched) {
//       setPincodeFetched(false);
//       setNewAddress(addr => ({
//         ...addr,
//         City: "",
//         State: ""
//       }));
//     }
//   }, [newAddress.Pincode]);



//   const fetchCityStateForPincode = async (pincode) => {
//     try {
//       const token = await user.getIdToken(true);
//       const response = await fetch(
//         `${API_URL}/checkPincodeServiceability?pincode=${pincode}`,
//         {
//           headers: {
//             "Authorization": `Bearer ${token}`,
//             "Content-Type": "application/json"
//           }
//         }
//       );
//       const data = await response.json();
//       if (data.serviceable) {
//         setNewAddress(addr => ({
//           ...addr,
//           City: data.city || "",
//           State: data.state || ""
//         }));
//         setPincodeFetched(true);
//         toast.success(`Autofilled city/state for pincode!`);
//       } else {
//         toast.dismiss();
//         toast.error("This Pincode is not serviceable.");
//         setNewAddress(addr => ({
//           ...addr,
//           City: "",
//           State: ""
//         }));
//         setPincodeFetched(false);
//       }
//     } catch (error) {
//       toast.error("Failed to fetch city/state.");
//       setPincodeFetched(false);
//     }
//   };



//   const navigate = useNavigate();
//   const location = useLocation();

//   useEffect(() => {
//     const redirectPath =
//       new URLSearchParams(location.search).get("redirect") || "/account";

//     const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
//       if (currentUser) {
//         setUser(currentUser);
//         setNewAddress({ ...newAddress, email: currentUser.email });

//         const userRef = doc(db, "customers", currentUser.uid);
//         const userDoc = await getDoc(userRef);

//         if (userDoc.exists()) {
//           setCustomer(userDoc.data());
//         } else {
//           await setDoc(userRef, { address: [], defaultAddress: -1 });
//           setCustomer({ address: [], defaultAddress: -1 });
//         }
//       } else {
//         setUser(null);
//         setCustomer(null);
//         navigate(`/login?redirect=${redirectPath}`);
//       }
//       setLoading(false);
//     });

//     return () => unsubscribe();
//   }, [navigate]);

//   const handleLogout = async () => {
//     await signOut(auth);
//     navigate("/login");
//   };

//   const handleAddOrEditAddress = async (e) => {
//     e.preventDefault();
//     if (
//       !newAddress.customerName ||
//       !newAddress.addressLine1 ||
//       !newAddress.addressLine2 ||
//       !newAddress.phone ||
//       !newAddress.City ||
//       !newAddress.State ||
//       !newAddress.Pincode
//     ) {
//       toast.error("Please fill in all required fields.");
//       // return;
//     }
//     toast.loading("Adding/Updating Address");
//     const cleanPincode = newAddress.Pincode.replace(/\s+/g, "");
//     const isServiceable = await checkPincodeServiceability(cleanPincode);
    
//     // Check if the Pincode is serviceable before proceeding
//     if (!isServiceable) {
//       toast.error("This Pincode is not serviceable. Please enter a valid Pincode.");
//       return;
//     }


//     const queryParams = new URLSearchParams(location.search);
//     const redirectPath = queryParams.get("redirect") || "/";

  
//     if (customer) {
//       const customerRef = doc(db, "customers", user.uid);
//       let updatedAddresses = [...(customer.address || [])];
  
//       if (editIndex !== null) {
//         updatedAddresses[editIndex] = newAddress;
//         toast.dismiss();
//         toast.success("Address updated successfully!");
//       } else {
//         if (updatedAddresses.length >= 2) {
//           toast.dismiss();

//           toast.error("You can only add up to 2 addresses.");
//           return;
//         }
//         updatedAddresses.push(newAddress);
//         toast.dismiss();

//         toast.success("Address added successfully!");
//       }
  
//       try {
//         await updateDoc(customerRef, {
//           address: updatedAddresses,
//         });
  
//         setCustomer({
//           ...customer,
//           address: updatedAddresses,
//         });
  
//         navigate(redirectPath);

//         setShowAddressForm(false);
//         setEditIndex(null);
//         setNewAddress({
//           customerName: "",
//           addressLine1: "",
//           addressLine2: "",
//           phone: "",
//           City: "",
//           State: "",
//           Country: "India",
//           Pincode: "",
//         });
//       } catch (error) {
//         console.error("Error saving address:", error);
//         alert("Error saving address. Please try again.");
//       }
//     }
//   };
  

//   const handleEditAddress = (index) => {
//     setEditIndex(index);
//     setNewAddress(customer.address[index]);
//     setShowAddressForm(true);
//   };


//   const checkPincodeServiceability = async (pincode) => {
//     try {
//       const token = await user.getIdToken(true);
//       const response = await fetch(
//         `${API_URL}/checkPincodeServiceability?pincode=${pincode}`,
//         {
//           headers: {
//             "Authorization": `Bearer ${token}`,
//             "Content-Type": "application/json"
//           }
//         }
//       );
//       const data = await response.json();
//       if (data.serviceable) {
//         // Optionally autofill city/state:
//         setNewAddress(addr => ({
//           ...addr,
//           City: data.city || "",
//           State: data.state || ""
//         }));
//         return true;
//       } else {
//         return false;
//       }
//     } catch (error) {
//       console.error("Error checking pincode:", error);
//       return false;
//     }
//   };
  
  


//   const handleSetDefaultAddress = async (index) => {
//     if (customer) {
//       const customerRef = doc(db, "customers", auth.currentUser.uid);

//       try {
//         await updateDoc(customerRef, { defaultAddress: index });

//         setCustomer({
//           ...customer,
//           defaultAddress: index,
//         });

//         toast.success("Default address updated!");

//         const redirectPath = new URLSearchParams(location.search).get("redirect");
//         if (redirectPath) {
//           navigate(redirectPath);
//         }
//       } catch (error) {
//         console.error("Error updating default address:", error);
//         alert("Failed to update address. Please try again.");
//       }
//     }
//   };

//   if (loading) {
//     return (
//       <div className="h-screen flex justify-center items-center">Loading...</div>
//     );
//   }

//   return (
//     <div className="max-w-4xl mt-27 mx-auto p-6">
//       <h1 className="text-3xl font-semibold text-gray-800">My Account</h1>

//       {user ? (
//         <div className="bg-white p-6 rounded-lg shadow-md mt-4">
//           <div className="mt-6">
//             <h2 className="text-lg font-semibold text-gray-700">Address</h2>
//             {customer?.address && customer.address.length > 0 ? (
//               <div className="space-y-4 mt-2">
//                 {customer.address.map((addr, index) => (
//                   <div key={index} className="bg-gray-100 p-4 rounded-lg flex items-center justify-between">
//                     <input
//                       type="radio"
//                       name="defaultAddress"
//                       checked={customer.defaultAddress === index}
//                       onChange={() => handleSetDefaultAddress(index)}
//                       className="h-5 w-5 text-orange-500 mr-2"
//                     />
//                     <div>
//                       <p className="font-semibold">{addr.customerName}</p>
//                       <p>{addr.addressLine1}</p>
//                       <p>{addr.addressLine2}</p>
//                       <p>{addr.City}, {addr.State}, {addr.Pincode}</p>
//                       <p>{addr.phone}</p>
//                       <p>{addr.Country || "India"}</p>
//                     </div>
//                     <button
//                       onClick={() => handleEditAddress(index)}
//                       className="text-blue-500 hover:underline"
//                     >
//                       Edit
//                     </button>
//                   </div>
//                 ))}
//               </div>
//             ) : (
//               <p className="text-gray-500 mt-2">No address available</p>
//             )}

//             {(customer?.address?.length < 3 || !customer?.address)  && (
//               <button
//                 onClick={() => setShowAddressForm(true)}
//                 className="mt-4 bg-orange-500 text-white px-4 py-2 rounded-lg hover:bg-orange-600 transition"
//               >
//                 Add Address
//               </button>
//             )}
//           </div>

//           {/* Address Modal */}
//           {showAddressForm && (
//             <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//               <div className="bg-white p-6 rounded-lg shadow-lg max-w-lg w-full">
//                 <h2 className="text-lg font-semibold text-gray-700">
//                   {editIndex !== null ? "Edit Address" : "Add Address"}
//                 </h2>
//                 <form onSubmit={handleAddOrEditAddress} className="space-y-3">
//                 <input
//   name="customerName"
//   autoComplete="name"
//   type="text"
//   placeholder="Full Name"
//   value={newAddress.customerName}
//   onChange={(e) => setNewAddress({ ...newAddress, customerName: e.target.value })}
//   className="w-full p-2 border rounded"
//   required
// />
// <input
//   name="phone"
//   autoComplete="tel"
//   type="tel"
//   placeholder="Phone"
//   value={newAddress.phone}
//   onChange={(e) => setNewAddress({ ...newAddress, phone: e.target.value })}
//   className="w-full p-2 border rounded"
//   required
// />
// <input
//   name="addressLine1"
//   autoComplete="address-line1"
//   type="text"
//   placeholder="Address Line 1"
//   value={newAddress.addressLine1}
//   onChange={(e) => setNewAddress({ ...newAddress, addressLine1: e.target.value })}
//   className="w-full p-2 border rounded"
//   required
// />
// <input
//   name="addressLine2"
//   autoComplete="address-line2"
//   type="text"
//   placeholder="Address Line 2"
//   value={newAddress.addressLine2}
//   onChange={(e) => setNewAddress({ ...newAddress, addressLine2: e.target.value })}
//   className="w-full p-2 border rounded"
//   required
// />

// <input
//   name="Pincode"
//   autoComplete="postal-code"
//   type="text"
//   placeholder="Pincode"
//   value={newAddress.Pincode}
//   onChange={(e) =>
//     setNewAddress({
//       ...newAddress,
//       Pincode: e.target.value.replace(/\s+/g, ""),
//     })
//   }
//   className="w-full p-2 border rounded"
//   required
// />


// <input
//   name="City"
//   autoComplete="address-level2"
//   type="text"
//   placeholder="City"
//   value={newAddress.City}
//   onChange={(e) => setNewAddress({ ...newAddress, City: e.target.value })}
//   className="w-full p-2 border rounded"
//   required
// />
// <input
//   name="State"
//   autoComplete="address-level1"
//   type="text"
//   placeholder="State"
//   value={newAddress.State}
//   onChange={(e) => setNewAddress({ ...newAddress, State: e.target.value })}
//   className="w-full p-2 border rounded"
//   required
// />

//    <button type="submit" className="w-full bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600 transition">Save</button>
//                   <button type="button" onClick={() => setShowAddressForm(false)} className="w-full bg-gray-300 text-gray-700 px-4 py-2 rounded-lg mt-2">Cancel</button>
//                 </form>
//               </div>
//             </div>
//           )}
//         </div>
//       ) : (
//         <p className="text-gray-700 mt-20 mb-20">Please log in to view account details.</p>
//       )}
//     </div>
//   );
// };

// export default Account;


import React, { useEffect, useState } from "react";
import { auth, firestore as db } from "../FirebaseConfig";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc, updateDoc, setDoc } from "firebase/firestore";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const Account = () => {
  // Initial empty state for resetting
  const emptyAddress = {
    customerName: "",
    addressLine1: "",
    addressLine2: "",
    email: "",
    phone: "",
    City: "",
    State: "",
    Country: "India",
    Pincode: "",
  };

  const [user, setUser] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [newAddress, setNewAddress] = useState(emptyAddress);
  const [pincodeFetched, setPincodeFetched] = useState(false);

  const API_URL = "https://us-central1-tghc-web.cloudfunctions.net";
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
    const redirectPath = queryParams.get("redirect") || "/";



  // --- Logic for Pincode ---
  useEffect(() => {
    const pincode = newAddress.Pincode;
    if (/^\d{6}$/.test(pincode) && !pincodeFetched) {
      fetchCityStateForPincode(pincode);
    }
    if (pincode.length !== 6 && pincodeFetched) {
      setPincodeFetched(false);
      setNewAddress(prev => ({ ...prev, City: "", State: "" }));
    }
  }, [newAddress.Pincode]);

  const fetchCityStateForPincode = async (pincode) => {
    try {
      const token = await user.getIdToken(true);
      const response = await fetch(`${API_URL}/checkPincodeServiceability?pincode=${pincode}`, {
        headers: { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" }
      });
      const data = await response.json();
      if (data.serviceable) {
        setNewAddress(prev => ({ ...prev, City: data.city || "", State: data.state || "" }));
        setPincodeFetched(true);
      }
    } catch (error) { console.error(error); }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        const userDoc = await getDoc(doc(db, "customers", currentUser.uid));
        if (userDoc.exists()) {
          setCustomer(userDoc.data());
        } else {
          const initialData = { address: [], defaultAddress: -1 };
          await setDoc(doc(db, "customers", currentUser.uid), initialData);
          setCustomer(initialData);
        }
      } else {
        navigate(`/login?redirect=${location.pathname}`);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, [navigate]);

  // --- Fixed: Reset Form Function ---
  const handleOpenAddAddress = () => {
    setEditIndex(null);
    setNewAddress({ ...emptyAddress, email: user?.email || "" });
    setShowAddressForm(true);
  };

  const handleOpenEditAddress = (index) => {
    setEditIndex(index);
    setNewAddress(customer.address[index]);
    setShowAddressForm(true);
  };

  const handleAddOrEditAddress = async (e) => {
    e.preventDefault();
    toast.loading("Saving address...");
    
    if (customer) {
      const customerRef = doc(db, "customers", user.uid);
      let updatedAddresses = [...(customer.address || [])];

      if (editIndex !== null) {
        updatedAddresses[editIndex] = newAddress;
      } else {
        if (updatedAddresses.length >= 2) {
          toast.dismiss();
          toast.error("Max 2 addresses allowed");
          return;
        }
        updatedAddresses.push(newAddress);
      }

      try {
        await updateDoc(customerRef, { address: updatedAddresses });
        setCustomer({ ...customer, address: updatedAddresses });
        setShowAddressForm(false);
        toast.dismiss();

        toast.success(editIndex !== null ? "Address updated!" : "Address added!");
                        navigate("/checkout");

      } catch (error) {
        toast.dismiss();
        toast.error("Failed to save.");
      }
    }
  };

  const handleSetDefaultAddress = async (index) => {
    const customerRef = doc(db, "customers", user.uid);
    await updateDoc(customerRef, { defaultAddress: index });
    setCustomer({ ...customer, defaultAddress: index });
    toast.success("Default address updated");
  };

  if (loading) return <div className="h-screen flex justify-center items-center text-orange-500">Loading...</div>;

  return (
    <div className="max-w-2xl mt-24 mx-auto p-4 md:p-6 mb-10">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">My Account</h1>
        <button onClick={() => signOut(auth)} className="text-sm font-medium text-red-500">Logout</button>
      </div>

      {user && (
        <section className="bg-white p-4 md:p-6 rounded-2xl border border-gray-100 shadow-sm">
          <h2 className="text-lg font-semibold text-gray-700 mb-4">Saved Addresses</h2>
          
          <div className="space-y-4">
            {customer?.address?.map((addr, index) => (
              <div 
                key={index}
                className={`p-4 rounded-xl border-2 transition-all cursor-pointer ${
                  customer.defaultAddress === index ? "border-orange-500 bg-orange-50/30" : "border-gray-100 bg-gray-50"
                }`}
                onClick={() => handleSetDefaultAddress(index)}
              >
                {/* Header Row: Prevents Overlap */}
                <div className="flex justify-between items-start mb-2">
                  <div className="flex items-center gap-2">
                    <span className="font-bold text-gray-800">{addr.customerName}</span>
                    {customer.defaultAddress === index && (
                      <span className="bg-orange-500 text-white text-[10px] px-2 py-0.5 rounded-full font-bold uppercase">Default</span>
                    )}
                  </div>
                  <button 
                    onClick={(e) => { e.stopPropagation(); handleOpenEditAddress(index); }}
                    className="text-orange-600 text-sm font-bold bg-white px-3 py-1 rounded-lg border border-orange-100 shadow-sm"
                  >
                    Edit
                  </button>
                </div>

                <p className="text-gray-600 text-sm leading-relaxed">
                  {addr.addressLine1}, {addr.addressLine2}<br/>
                  {addr.City}, {addr.State} - {addr.Pincode}
                </p>
                <p className="text-gray-800 text-sm mt-2 font-medium">{addr.phone}</p>
              </div>
            ))}
          </div>

          {(!customer?.address || customer.address.length < 2) && (
            <button
              onClick={handleOpenAddAddress}
              className="mt-6 w-full py-4 border-2 border-dashed border-gray-200 rounded-xl text-gray-500 font-medium hover:border-orange-300 hover:text-orange-500 transition-all"
            >
              + Add New Address
            </button>
          )}
        </section>
      )}

      {/* Responsive Form Modal */}
      {showAddressForm && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-end md:items-center z-50 p-0 md:p-4">
          <div className="bg-white p-6 rounded-t-3xl md:rounded-2xl w-full max-w-lg shadow-2xl animate-in slide-in-from-bottom duration-300">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-bold text-gray-800">{editIndex !== null ? "Edit Address" : "New Address"}</h2>
              <button onClick={() => setShowAddressForm(false)} className="text-gray-400 p-2"><svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg></button>
            </div>
            
            <form onSubmit={handleAddOrEditAddress} className="space-y-4 max-h-[75vh] overflow-y-auto pb-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="space-y-1">
                  <label className="text-xs font-semibold text-gray-500 ml-1">Full Name</label>
                  <input type="text" placeholder="Full Name" value={newAddress.customerName} onChange={(e) => setNewAddress({ ...newAddress, customerName: e.target.value })} className="input-field" required />
                </div>
                <div className="space-y-1">
                  <label className="text-xs font-semibold text-gray-500 ml-1">Phone Number</label>
                  <input type="tel" placeholder="Mobile Number" value={newAddress.phone} onChange={(e) => setNewAddress({ ...newAddress, phone: e.target.value })} className="input-field" required />
                </div>
              </div>

              <div className="space-y-1">
                <label className="text-xs font-semibold text-gray-500 ml-1">Flat / House No.</label>
                <input type="text" placeholder="Address Line 1" value={newAddress.addressLine1} onChange={(e) => setNewAddress({ ...newAddress, addressLine1: e.target.value })} className="input-field" required />
              </div>

              <div className="space-y-1">
                <label className="text-xs font-semibold text-gray-500 ml-1">Area / Landmark</label>
                <input type="text" placeholder="Address Line 2" value={newAddress.addressLine2} onChange={(e) => setNewAddress({ ...newAddress, addressLine2: e.target.value })} className="input-field" required />
              </div>

              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                <div className="space-y-1">
                  <label className="text-xs font-semibold text-gray-500 ml-1">Pincode</label>
                  <input type="text" placeholder="6-digits" value={newAddress.Pincode} onChange={(e) => setNewAddress({ ...newAddress, Pincode: e.target.value.replace(/\D/g, "") })} className="input-field" required />
                </div>
                <div className="space-y-1">
                  <label className="text-xs font-semibold text-gray-500 ml-1">City</label>
                  <input type="text" value={newAddress.City} readOnly className="input-field bg-gray-50 cursor-not-allowed" />
                </div>
                <div className="space-y-1 md:col-span-1 col-span-2">
                  <label className="text-xs font-semibold text-gray-500 ml-1">State</label>
                  <input type="text" value={newAddress.State} readOnly className="input-field bg-gray-50 cursor-not-allowed" />
                </div>
              </div>

              <div className="pt-4 flex flex-col gap-2">
                <button type="submit" className="w-full bg-orange-500 text-white py-4 rounded-xl font-bold shadow-lg shadow-orange-100 hover:bg-orange-600 transition-all">Save Address</button>
                <button type="button" onClick={() => setShowAddressForm(false)} className="w-full py-2 text-gray-400 text-sm font-medium">Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <style jsx>{`
        .input-field {
          width: 100%;
          padding: 14px;
          border: 1px solid #f3f4f6;
          border-radius: 12px;
          font-size: 15px;
          background: #fdfdfd;
          outline: none;
          transition: all 0.2s;
        }
        .input-field:focus {
          border-color: #f97316;
          background: #fff;
          box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.05);
        }
      `}</style>
    </div>
  );
};

export default Account;